import { useEffect, useState } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";
import Header from "modules/main/components/header";
import { ProductSheet } from "modules/product/components/product-sheet";
import { useLocation, useParams } from "react-router-dom";
import { isDesktopSize } from "utils/is-desktop";
import { usePageTitle } from "hooks/usePageTitle";
import {
  PageBreadcrumbs,
  PageBreadcrumb,
} from "modules/main/components/page-breadcrumbs";

export const ProductPage = () => {        
    const pathParams =  useParams();
    const isDesktop = useMediaQuery(isDesktopSize)
    const location = useLocation();
    const { setBreadcrumb, setShowBack } = usePageTitle();
    const [productName, setProductName] = useState<string | null>(null);

    // Navigation-origin detection: product links (ProductCard) pass
    // state={{ from: location.pathname }}; a /search/* origin swaps the middle
    // crumb to "Resultados búsqueda" linking back verbatim (binary rule).
    const from = (location.state as { from?: string } | null)?.from;
    const fromSearch = typeof from === "string" && from.startsWith("/search");

    // Breadcrumb declared via setBreadcrumb (HeaderBar renders it instead of
    // the h2). Explicit primitive deps — never set inline (fresh JSX identity
    // every render would loop). No name while loading → 2 crumbs, never empty.
    useEffect(() => {
        const crumbs: PageBreadcrumb[] = [
            { label: "Inicio", to: "/store" },
            fromSearch && from
                ? { label: "Resultados búsqueda", to: from }
                : { label: "Catálogo", to: "/catalog" },
        ];
        if (productName) {
            crumbs.push({ label: productName });
        }
        setBreadcrumb(<PageBreadcrumbs crumbs={crumbs} />);
        // EXTENSION 8: defensively reset the global back arrow so a stale
        // ArrowLeft from a previous route never shows on this breadcrumb route.
        setShowBack(false);
        return () => setBreadcrumb(null);
    }, [from, fromSearch, productName, setBreadcrumb, setShowBack]);

    return (
        <>
        <div className="flex w-full m-auto">
            <ProductSheet 
                productID={pathParams.p??""}
                isMobile={!isDesktop}
                onNameChange={setProductName}
            />
        </div>
        </>
    );
}